import React from 'react';
import { UnorderedList, ListItem } from '@hover/blueprint';
import { IPricingTooltip } from '../../../interfaces/IPricingTooltip';
import PricingTooltip from './PricingTooltip';

interface Props {
  data: IPricingTooltip[];
}

const PricingTooltipsList: React.FC<Props> = ({ data }) => (
  <UnorderedList spacing={500}>
    {data.map((tooltip: IPricingTooltip) => (
      <ListItem key={tooltip.id}>
        <PricingTooltip tooltip={tooltip} />
      </ListItem>
    ))}
  </UnorderedList>
);

export default PricingTooltipsList;
